import React from "react";
import { Box } from "@mui/material";
import pencilIcon from "@iconify/icons-mdi/pencil";
import { InlineIcon } from "@iconify/react";

interface OcDataTableBodyCellEditIconProps {
  row: {
    icons?: { edit?: boolean };
    date?: string | number | Date;
    [key: string]: any;
  };
  isNotExaminer: boolean;
  handleSelectRow: (params: { action: string; row: any }) => void;
  buttonStyle?: React.CSSProperties;
}

export const OcDataTableBodyCellEditIcon: React.FC<
  OcDataTableBodyCellEditIconProps
> = ({ row, isNotExaminer, handleSelectRow, buttonStyle }) => {
  if (row?.icons?.edit === false || isNotExaminer) return null;
  return (
    <Box
      onClick={() => handleSelectRow({ action: "edit", row: row })}
      style={buttonStyle}
    >
      <InlineIcon
        width="24px"
        height="24px"
        id={`edit-${new Date(row?.date || Date.now()).getDate()}`}
        icon={pencilIcon}
      />
    </Box>
  );
};

export default OcDataTableBodyCellEditIcon;
